import { t } from 'i18next';
import type { ReactNode } from 'react';
import loadingGif from '../assets/loading.gif';
import type { I18nPrefix } from '../i18n/prefix';

const COMPONENT = 'components:loading_screen' satisfies I18nPrefix;

export function LoadingScreen({ message = t('aria:loading') }: { message?: ReactNode }) {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-spark-surface-page">
      <div className="m-auto block p-6">
        <div className="m-auto block items-center rounded border border-spark-border-default bg-spark-surface p-4 shadow sm:w-25">
          <img src={loadingGif} className="m-auto block w-15" alt={t(`${COMPONENT}.image_alt`)} />
        </div>
        <p className="mt-6 text-center font-bold text-spark-text-primary sm:text-xl">{message}</p>
      </div>
    </div>
  );
}
